import {
  CreateSiteCommand,
} from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticationToken } from "../../auth/helpers";
import { setupClaimIntakeClient } from "../setup/setupClaimIntakeClient";
import { MetricsPublisher } from "../../metrics/metrics";
import { Site } from "src/sites/types";

export async function createSiteService(site: Site) {
  const token = await getAuthenticationToken();
  if (!token) {
    Promise.reject(new Error("Unauthorized"));
  }
  const client = setupClaimIntakeClient(token);
  const command = new CreateSiteCommand(site);
  const metricsPublisher = new MetricsPublisher("api.createSite");

  return await client
    .send(command)
    .then((response: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
